<template>
  <div class="setting-drawer-index-handle">
    <i class="el-icon-biji" aria-label="笔记" data-track-text="笔记" @click="handleClick('note')"></i>
    <i class="el-icon-AIwenda" aria-label="AI问答" data-track-text="AI问答" @click="handleClick('aiTalk')"></i>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: "DarggDrawer",
  // 注册组件
  components: {},
  // 变量声明
  data() {
    return {
      visible: false, // 是否显示
      mouseDownX: 0,
      mouseDownY: 0,
      deltaX: 0,
      deltaY: 0,
      sumX: 0,
      sumY: 0,
      isMove: false,

      modalContent: null,
      moveFalg: true,
    };
  },
  // 实例销毁之前
  beforeDestroy() {
    this.removeMove();
    window.removeEventListener("pointerup", this.removeUp, false);
    window.removeEventListener("pointercancel", this.removeUp, false);
    if (this.modalContent) this.modalContent.onpointerdown = null;
  },
  // 实例被挂载后调用，vm.$el可调用，不会保证所有的子组件也都被挂载完成，可以在 mounted 内部使用 vm.$nextTick
  mounted() {
    this.$nextTick(() => {
      this.initialEvent();
    });
  },
  // 方法
  methods: {
    handleMove(event) {
      this.isMove = true;
      let delta1X = event.pageX - this.mouseDownX;
      let delta1Y = event.pageY - this.mouseDownY;
      const countXR =
        document.body.offsetWidth -
        (this.modalContent.offsetLeft + this.modalContent.offsetWidth);
      const countXL = 0 - this.modalContent.offsetLeft;
      const countYB =
        document.body.offsetHeight -
        (this.modalContent.offsetTop + this.modalContent.offsetHeight);
      const countYT = 0 - this.modalContent.offsetTop;
      //x坐标计算
      if (delta1X + this.sumX > countXR) {
        delta1X = countXR - this.sumX;
      }
      if (delta1X + this.sumX < countXL) {
        delta1X = countXL - this.sumX;
      }
      //y坐标计算
      if (delta1Y + this.sumY > countYB) {
        delta1Y = countYB - this.sumY;
      }
      if (delta1Y + this.sumY < countYT) {
        delta1Y = countYT - this.sumY;
      }

      this.deltaX = delta1X;
      this.deltaY = delta1Y;
      if (delta1X !== 0 || delta1Y !== 0) {
        this.isMove = true;
        this.moveFalg = false;
      }
      this.modalContent.style.transform = `translate(${
        this.deltaX + this.sumX
      }px, ${this.deltaY + this.sumY}px)`;
    },
    initialEvent(visible) {
      this.sumY = 0;
      this.sumX = 0;
      setTimeout(() => {
        window.removeEventListener("mouseup", this.removeUp, false);
      this.modalContent = document.getElementsByClassName(
          "setting-drawer-index-handle"
        )[0];

        if (!this.modalContent) return;

        this.modalContent.style.right = "10px";
        this.modalContent.style.transform = "translate(0px,0px)";
        this.modalContent.style.cursor = "grab";

        this.modalContent.onpointerdown = (e) => {
          if (e.button !== undefined && e.button !== 0) return;
          e.preventDefault();
          this.isMove = false;
          this.mouseDownX = e.pageX;
          this.mouseDownY = e.pageY;
          this.modalContent.style.cursor = "grabbing";
          document.body.onselectstart = () => false;
          window.addEventListener("pointermove", this.handleMove, false);
        };

        window.addEventListener("pointerup", this.removeUp, false);
        window.addEventListener("pointercancel", this.removeUp, false);
      }, 0);
    },
    removeMove() {
      this.isMove = false;
      window.removeEventListener("pointermove", this.handleMove, false);
    },
    removeUp(e) {
      document.body.onselectstart = () => true;
      if (this.modalContent) this.modalContent.style.cursor = "grab";
      if (
        !(e.pageX == this.mouseDownX && e.pageY == this.mouseDownY) &&
        this.isMove
      ) {
        this.sumX += this.deltaX;
        this.sumY += this.deltaY;
      }
      this.removeMove();
    },
    handleClick(type) {
      this.$emit("handleClick", type);
    },
  },
};
</script>

<style lang="less" scoped>
.setting-drawer-index-handle {
  position: absolute;
  top: 260px;
  width: 46px;
  height: 100px;
  right: 10px;
  cursor: grab;
  touch-action: none;
  pointer-events: auto;
  z-index: 9;
  text-align: center;
  font-size: 20px;
  z-index: 28;
  background: #ffffff;
  border-radius: 23px;
  color: var(--primary-dark);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 1px solid #dce4e7;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.14);

  i {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: color 0.16s ease, background 0.16s ease;

    &:hover {
      color: #ffffff;
      background: var(--primary);
    }
  }
}

@media (max-width: 768px) {
  .setting-drawer-index-handle {
    position: fixed;
    top: auto;
    right: 12px;
    bottom: calc(70px + env(safe-area-inset-bottom));
    width: 94px;
    height: 44px;
    flex-direction: row;
    gap: 8px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(8px);
  }
}
</style>
